import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    connect() {
        document.addEventListener('show-toast', this.showToast.bind(this))
    }

    showToast(event) {
        const { message, type } = event.detail
        const toast = this.createToastElement(message, type)
        this.element.appendChild(toast)

        setTimeout(() => {
            toast.classList.add('opacity-0')
            setTimeout(() => toast.remove(), 300)
        }, 6000)
    }

    createToastElement(message, type = 'add') {
        const toast = document.createElement('div')
        
        const colors = {
            add: {
                background: '#E8F5E9',
                border: '#144618',
                text: '#707625'
            },
            remove: {
                background: '#FFEBEE',
                border: '#B83E26',
                text: '#B83E26'
            }
        }
        
        const classes = ['w-[90vw]', 'max-w-[448px]', 'mb-3', 'p-4', 'rounded-[4px]', 'shadow-lg', 'border-2', 'transform', 'transition-all', 'duration-300', 'flex', 'items-center'];
        classes.forEach(cls => toast.classList.add(cls));
        
        toast.style.borderColor = colors[type]?.border || colors.add.border
        toast.style.color = colors[type]?.text || colors.add.text
        toast.style.backgroundColor = colors[type]?.background || colors.add.background

        const icon = type === 'add' 
            ? '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"<g clip-path="url(#clip0_5157_957)"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 2.66667C8.6362 2.66667 2.66667 8.6362 2.66667 16C2.66667 23.3638 8.6362 29.3333 16 29.3333C23.3638 29.3333 29.3333 23.3638 29.3333 16C29.3333 8.6362 23.3638 2.66667 16 2.66667ZM0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z" fill="#144618"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.4063 10.8906C22.019 11.2991 22.1845 12.1269 21.7761 12.7396L16.4427 20.7396C16.0343 21.3523 15.2064 21.5179 14.5937 21.1094L10.5937 18.4427C9.98104 18.0343 9.81547 17.2064 10.2239 16.5937C10.6324 15.981 11.4602 15.8155 12.0729 16.2239L14.9635 18.151L19.5573 11.2604C19.9657 10.6477 20.7936 10.4821 21.4063 10.8906Z" fill="#144618"/></g><defs><clipPath id="clip0_5157_957"><rect width="32" height="32" fill="white"/></clipPath></defs></svg>'
            : '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10 5C10.5523 5 11 5.44772 11 6V10C11 10.5523 10.5523 11 10 11C9.44771 11 9 10.5523 9 10V6C9 5.44772 9.44771 5 10 5ZM9 14C9 13.4477 9.44771 13 10 13H10.01C10.5623 13 11.01 13.4477 11.01 14C11.01 14.5523 10.5623 15 10.01 15H10C9.44771 15 9 14.5523 9 14Z" fill="currentColor"/></svg>'

        toast.innerHTML = `
            <div class="flex items-center justify-between w-full">
                <div class="flex items-center">
                    ${icon}
                    <span class="ml-4">${message}</span>
                </div>
                <div class="flex items-center space-x-2">
                    <a href="/my-careers/" class="font-bold whitespace-nowrap ${type === 'add' ? 'text-[#144618]' : 'text-[#891515]'} uppercase text-xs">
                        View Careers
                    </a>
                    <button type="button" class="ml-4 hover:opacity-80" data-action="click->toast#closeToast">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M1.08748 1.0876C1.31529 0.859797 1.68463 0.859797 1.91244 1.0876L4.99996 4.17512L8.08748 1.0876C8.31529 0.859797 8.68463 0.859797 8.91244 1.0876C9.14024 1.31541 9.14024 1.68475 8.91244 1.91256L5.82492 5.00008L8.91244 8.0876C9.14024 8.31541 9.14024 8.68475 8.91244 8.91256C8.68463 9.14037 8.31529 9.14037 8.08748 8.91256L4.99996 5.82504L1.91244 8.91256C1.68463 9.14037 1.31529 9.14037 1.08748 8.91256C0.859675 8.68475 0.859675 8.31541 1.08748 8.0876L4.175 5.00008L1.08748 1.91256C0.859675 1.68475 0.859675 1.31541 1.08748 1.0876Z" fill="#353436"/>
                        </svg>
                    </button>
                </div>
            </div>
        `

        return toast
    }

    disconnect() {
        document.removeEventListener('show-toast', this.showToast.bind(this))
    }

    closeToast(event) {
        const toast = event.currentTarget.closest('div[class*="max-w-[448px]"]')
        if (toast) {
            toast.classList.add('opacity-0')
            setTimeout(() => toast.remove(), 300)
        }
    }
}
